export default class Marshaller {

	static marshallDaySpan(daySpan) {
		if (!daySpan)
			return '0';

		var value = daySpan.value;
		if (daySpan.unit == '-w') {
			value *= -7;
		} else if (daySpan.unit == '-d') {
			value *= -1;
		} else if (daySpan.unit == 'w') {
			value *= 7;
		}

		return value;
	}

	static marshallProject(project) {
		if (!project)
			return null;

		var result = {
			name: project.name,
			autoSprintDaysAhead: this.marshallDaySpan(project.autoSprintDaysAhead),
			autoSprintEveryDays: this.marshallDaySpan(project.autoSprintEveryDays),
			autoSprintTemplate: this.marshallSprint(project.autoSprintTemplate),
			sprintsToKeep: project.sprintsToKeep
		};

		result.sprints = $.map(project.sprints, sprint => {
			return Marshaller.marshallSprint(sprint);
		});

		return result;
	}

	static marshallSprint(sprint) {
		if (!sprint)
			return null;

		var result = {
			name: sprint.name,
			start: sprint.start,
			endOffset: Marshaller.marshallDaySpan(sprint.endOffset)
		};

		result.phases = $.map(sprint.phases, phase => {
			return {
				offset: Marshaller.marshallDaySpan(phase.offset),
				name: phase.name,
				color: phase.color,
				type: phase.type
			};
		});

		return result;
	}

	static unmarshallDaySpan(days) {
		if (!days)
			return {unit: '0', value: 0};

		var value = parseInt(days, 10);

		var unit;
		if (value == 0) {
			unit = '0';
		} else if (value % 7 == 0) {
			value /= 7;
			unit = value < 0 ? '-w' : 'w';
		} else {
			unit = value < 0 ? '-d' : 'd';
		}

		return {
			unit: unit,
			value: Math.abs(value)
		};
	}

	static unmarshallProject(project) {
		var result = JSON.parse(JSON.stringify(project));

		result.autoSprintTemplate = this.unmarshallSprint(project.autoSprintTemplate);

		result.sprints = $.map(project.sprints, sprint => {
			return Marshaller.unmarshallSprint(sprint);
		});

		result.autoSprintDaysAhead = this.unmarshallDaySpan(project.autoSprintDaysAhead);
		result.autoSprintEveryDays = this.unmarshallDaySpan(project.autoSprintEveryDays);

		return result;
	}

	static unmarshallSprint(sprint) {
		if (!sprint)
			return null;

		var start = sprint.start;
		sprint = JSON.parse(JSON.stringify(sprint));
		sprint.start = start;

		$.each(sprint.phases, (index, phase) => {
			phase.offset = Marshaller.unmarshallDaySpan(phase.offset);
		});
		sprint.endOffset = Marshaller.unmarshallDaySpan(sprint.endOffset);

		return sprint;
	}

}
